import axios from 'axios'

const api = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/changechip'
})

export default api;
